import React from 'react';
import { profile } from '../mock';

export default function Footer() {
  return (
    <footer className="relative pt-20 pb-10 border-t border-cream overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between flex-wrap gap-8 mb-12">
          <h3 className="font-display text-cream leading-[0.85] text-[18vw] md:text-[14vw]">
            Shreya<span className="text-orange-acc">.</span>
          </h3>
          <a
            href="#top"
            className="text-[11px] uppercase tracking-[0.3em] text-cream hover:text-orange-acc"
          >
            Back to top ↗
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-cream/15 text-[11px] uppercase tracking-[0.28em] text-cream-soft/65">
          <span>© {new Date().getFullYear()} {profile.name}</span>
          <span>Designed &amp; coded with care</span>
          <span>Portfolio {profile.year}</span>
        </div>
      </div>
    </footer>
  );
}
